import { Component, OnInit } from "@angular/core";
import {
  ActivatedRoute,
  ParamMap,
  Router,
  NavigationExtras
} from "@angular/router";
import { LotService } from "../../core/services/lot.service";
import { Lot } from "../../core/models/lot.model";
import { EmployeeService } from "../../core/services/employee.service";
import { Pagination } from "../../core/models/pagination.model";
import { ExportExcelComponent } from "../../common/export-excel/export-excel.component";
import { CommonService } from "../../core/services/common.service";
import { FormGroup, FormBuilder } from "@angular/forms";

@Component({
  selector: "app-lot-show",
  templateUrl: "./lot-show.component.html",
  styleUrls: ["./lot-show.component.css"]
})
export class LotShowComponent extends ExportExcelComponent implements OnInit {
  lotId: number;
  lot: Lot = new Lot();
  verificationStats: any[] = [];
  verifications: any[] = [];
  statsLoaded: boolean = false;
  lotVerifications: any[];
  fetchingInProgress = false;
  filterFormGroup: FormGroup;

  filterParams: URLSearchParams = new URLSearchParams();
  loading: boolean;
  pagination: Pagination = new Pagination();

  constructor(
    private route: ActivatedRoute,
    private lotService: LotService,
    private employeeService: EmployeeService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
    this.route.params.subscribe(params => {
      // (+) converts string 'id' to a number
      this.lotId = +params["id"];

      //     this.filterResults();
    });

    this.subscribeToQueryChanges();
    // Fetch Lot Details
    this.route.paramMap
      .switchMap((params: ParamMap) => this.lotService.find(+params.get("id")))
      .subscribe(lot => {
        this.lot = lot;
        this.lotVerifications = this.lot.unique_verifications;
      });

    this.route.paramMap
      .switchMap((params: ParamMap) => this.lotService.find(+params.get("id")))
      .subscribe(lot => {
        this.lot = lot;
        this.lotVerifications = this.lot.unique_verifications;
      });
  }

  initForm(): void {
    this.filterFormGroup = this.fb.group({
      employee_created_after: "all",
      employee_created_before: "all"
    });
  }

  filterResults(): void {
    this.route.paramMap
      .switchMap((params: ParamMap) =>
        this.lotService.stats(+params.get("id"), this.filterParams)
      )
      .subscribe(stats => {
        this.verifications = stats["verifications"];
        this.parseStats(stats["statsByStatusType"]);
        this.statsLoaded = true;
      });
    this.employeeService
      .getByLot(this.lotId, this.filterParams)
      .subscribe(pagination => (this.pagination = pagination));
  }

  subscribeToQueryChanges() {
    this.route.queryParams.subscribe(params => {
      Object.keys(params).forEach(key => {
        if (params[key] !== "") {
          this.filterParams.set(key, params[key]);
        }
      });
      this.filterResults();
    });
  }

  parseStats(stats: any[]): void {
    Object.keys(stats).forEach(key => {
      if (stats[key] !== "") {
        this.verificationStats[key] = stats[key];
      }
    });
  }

  // Export the employees list on the current page.
  exportExcel() {
    this.fetchingInProgress = true;
    this.lotService.getDataForExcel(this.lotId, this.filterParams).subscribe(
      response => {
        if (response) {
          this.downloadExcel(response, this.lot.name);
          this.fetchingInProgress = false;
          this.commonService.notifications.success(
            "Success",
            "Excel Downloaded Successfully"
          );
        } else {
          this.commonService.notifications.error(
            "Error",
            "You are not authorised"
          );
          this.fetchingInProgress = false;
        }
      },
      error => {
        this.commonService.notifications.error("Error", "Something went wrong");
        this.fetchingInProgress = false;
      }
    );
  }

  filterQueriedResults(): void {
    this.filterParams = new URLSearchParams();

    // Set our navigation extras object
    // that contains our global query params and fragment
    const navigationExtras: NavigationExtras = {
      queryParams: this.filterFormGroup.value,
      queryParamsHandling: "merge"
    };

    // Get the current path
    const currentUrlPath = this.router.url.split("?")[0];

    this.router.navigate([currentUrlPath], navigationExtras);
  }

  // Reset the form to its initial state with default value
  // And then filter results
  resetForm(): void {
    this.initForm();
    this.filterQueriedResults();
  }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/lot/lot-show/lot-show.component.ts